<template>
  <div class="page">
    <!-- ÜST BAŞLIK -->
    <div class="page-header soft-card">
      <div>
        <div class="page-title">{{this.$store.aktifCari.unvan}}</div>
        <div class="page-subtitle">
          Tarih, ödeme ve teslim bilgilerini girin; aşağıdan ürünleri seçip teklifi oluşturun.
        </div>
      </div>
    </div>

    <!-- GENEL BİLGİLER KARTI -->
    <div class="card soft-card">
      <div class="card-body">
        <div class="form-row">
          <div class="form-group">
            <label>Tarih</label>
            <input
              type="date"
              class="form-control"
              v-model="form.tarih"
            >
          </div>

          <div class="form-group">
            <label>Ödeme Şekli</label>
            <select
              class="form-control"
              v-model="form.odemeSekli"
            >
              <option disabled value="">Seçiniz</option>
              <option v-for="o in odemeSekliOptions" :key="o.value" :value="o.value">
                {{ o.label }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>Teslim Şekli</label>
            <select
              class="form-control"
              v-model="form.teslimSekli"
            >
              <option disabled value="">Seçiniz</option>
              <option v-for="t in teslimSekliOptions" :key="t.value" :value="t.value">
                {{ t.label }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>Teklif Geçerlilik Tarihi</label>
            <input
              type="date"
              class="form-control"
              v-model="form.gecerlilikTarih"
            >
          </div>

          <!-- Teklif No + Kurlar -->
          <div class="form-group">
            <div class="form-group-header">
              <label>Teklif No</label>
              <div class="rates-inline">
                <strong>USD Kuru:</strong> {{ usdKuruText }} &nbsp;&nbsp;
                <strong>EUR Kuru:</strong> {{ eurKuruText }}
              </div>
            </div>
            <input
              type="text"
              class="form-control"
              v-model="form.teklifNo"
              placeholder="Opsiyonel teklif no"
            >
          </div>
          
        </div>
      </div>
    </div>

    <!-- ANA İÇERİK -->
    <div class="main-layout">
      <!-- SOL TARAF -->
      <div class="main-left">
        <!-- ÜRÜN ARAMA KARTI -->
        <div class="card soft-card">
            <!-- 🔥 BOŞ SATIR BUTONU (hem desktop hem mobil için ortak) -->
          <div class="card-body">
            <div class="search-wrapper">
              <div class="search-label-row">
                <span>Ürün Ara (İsim / Kod)</span> 
              </div>
              <div class="search-input-row">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Ürün ismi yazın, listeden seçin..."
                  v-model="productSearch"
                  @input="onProductSearchChange"
                  @focus="onProductSearchFocus"
                  @blur="onProductSearchBlur"
                >
              </div>

              <!-- DROPDOWN -->
              <ul
                v-if="showProductDropdown"
                class="product-dropdown"
              >
                <li
                  v-for="stok in searchResults"
                  :key="stok.id || stok.kod"
                  @mousedown.prevent="selectProduct(stok)"
                >
                  <div>
                    <span class="code">{{ stok.kod }}</span> {{ stok.isim }}
                  </div>
                  <div class="price">{{ formatCurrency(stok.listeFiyat || 0) }}</div>
                </li>

                <li v-if="searching" class="page-subtitle" style="padding:6px 12px;">
                  Aranıyor...
                </li>
                <li
                  v-if="!searching && searchResults.length === 0 && productSearch.length >= 2"
                  class="page-subtitle"
                  style="padding:6px 12px;"
                >
                  Sonuç bulunamadı
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- SATIR TABLOSU -->
        <div class="table-wrapper soft-card">
<!-- MOBİL SATIRLAR (telefon) -->


          <table>
<thead>
  <tr>
    <th class="th-no" style="width: 40px;">#</th>
    <th class="th-kod" style="width: 110px;">Stok Kodu</th>
    <th class="th-ad">Stok Adı</th>
    <th class="th-miktar" style="width: 70px;">Miktar</th>
    <th class="th-birim" style="width: 70px;">Birim</th>
    <th class="th-fiyat" style="width: 90px;">Liste Fiyatı</th>

    <th v-if="iskontoConfig.show1" class="th-isk1" style="width: 80px;">İsk1 %</th>
    <th v-if="iskontoConfig.show2" class="th-isk2" style="width: 80px;">İsk2 %</th>
    <th v-if="iskontoConfig.show3" class="th-isk3" style="width: 80px;">İsk3 %</th>

    <th class="th-kdv" style="width: 70px;">KDV %</th>
    <th class="th-net-tl" style="width: 110px;">Net (TL)</th>
    <th class="th-net-usd" style="width: 110px;">Net (USD)</th>
    <th class="th-actions" style="width: 90px;">İşlem</th>
  </tr>
</thead>

<tbody>
  <tr v-for="(row, index) in form.kalemler" :key="row.id">
    <!-- 1: Satır No -->
    <td class="cell-no text-center">
      {{ index + 1 }}
    </td>

    <!-- 2: Stok kodu (mobilde alt satırlarda olacak) -->
<td class="cell-kod">
  <template v-if="row.manual">
    <input
      type="text"
      class="cell-input"
      v-model="row.stokKod"
      placeholder="Kod"
    >
  </template>
  <template v-else>
    <span class="cell-text">{{ row.stokKod }}</span>
  </template>
</td>

<td class="cell-name">
  <template v-if="row.manual">
    <input
      type="text"
      class="cell-input"
      v-model="row.stokAd"
      placeholder="Ürün adı"
    >
  </template>
  <template v-else>
    <span class="cell-text">{{ row.stokAd }}</span>
  </template>
</td>


    <!-- 4: Miktar -->
    <td class="cell-qty">
      <input
        class="cell-input text-right"
        type="number"
        min="0"
        step="0.01"
        v-model.number="row.miktar"
      >
    </td>

    <!-- 5: Birim -->
<td class="cell-unit">
  <template v-if="row.manual">
    <select
      v-model="row.birim"
      class="cell-select"
    >
      <option
        v-for="u in unitOptions"
        :key="'unit-' + u"
        :value="u"
      >
        {{ u }}
      </option>
    </select>
  </template>

  <template v-else>
    <span class="cell-text">{{ row.birim }}</span>
  </template>
</td>


    <!-- 6: Liste fiyatı -->
<td class="cell-price text-left">
  <template v-if="row.manual">
    <input
      type="number"
      min="0"
      step="0.01"
      class="cell-input text-right"
      v-model.number="row.listeFiyat"
    >
  </template>
  <template v-else>
    <span class="cell-text">
      {{ formatCurrency(row.listeFiyat, 'TL') }}
    </span>
  </template>
</td>


    <!-- 7–9: İskontolar -->
    <td v-if="iskontoConfig.show1" class="cell-isk1">
      <select
        class="cell-select text-right"
        v-model.number="row.isk1"
        @change="onIskontoChange(row, 'isk1')"
      >
        <option v-for="i in iskontoOptions1" :key="'i1-' + i" :value="i">
          {{ i }}
        </option>
      </select>
    </td>

    <td v-if="iskontoConfig.show2" class="cell-isk2">
      <select
        class="cell-select text-right"
        v-model.number="row.isk2"
        @change="onIskontoChange(row, 'isk2')"
      >
        <option v-for="i in iskontoOptions2" :key="'i2-' + i" :value="i">
          {{ i }}
        </option>
      </select>
    </td>

    <td v-if="iskontoConfig.show3" class="cell-isk3">
      <select
        class="cell-select text-right"
        v-model.number="row.isk3"
        @change="onIskontoChange(row, 'isk3')"
      >
        <option v-for="i in iskontoOptions3" :key="'i3-' + i" :value="i">
          {{ i }}
        </option>
      </select>
    </td>

    <!-- 10: KDV -->
<td class="cell-kdv">
  <template v-if="row.manual">
    <input
      class="cell-input text-right"
      type="number"
      min="0"
      max="100"
      step="1"
      v-model.number="row.kdv"
    >
  </template>
  <template v-else>
    <span class="cell-text">
      {{ row.kdv }}%
    </span>
  </template>
</td>


    <!-- 11: Net TL -->
    <td class="cell-net-tl text-left" style=" font-weight: 600; font-size:13px">
      {{ formatCurrency(satirHesapla(row).genelSatirTutar, 'TL') }}
    </td>

    <!-- 12: Net USD -->
    <td class="cell-net-usd text-left" style=" font-weight: 600; font-size:13px">
      {{ formatCurrency(satirHesapla(row).usdNet, 'USD') }}
    </td>

    <!-- 13: İşlemler -->
    <td class="cell-actions">
      <div class="row-actions">
        <button class="btn-icon" title="Kopyala" @click="copyRow(index)">⧉</button>
        <button class="btn-icon danger" title="Sil" @click="removeRow(index)">  X  </button>
      </div>
    </td>
  </tr>
</tbody>

          </table>
        <div class="table-footer">
          <button class="btn btn-outline btn-sm btn-empty-row" @click="addEmptyRow">Boş Satır Ekle</button>
        </div>          
        </div>
<div class="mobile-rows">
  <div
    class="offer-row-card"
    v-for="(row, index) in form.kalemler"
    :key="'m-' + row.id"
  >
    <!-- ÜST SATIR: No | İsim | Miktar -->
    <div class="offer-row-top">
      <div class="offer-row-no">
        {{ index + 1 }}
      </div>
<div class="offer-row-name">
  <template v-if="row.manual">
    <input
      type="text"
      v-model="row.stokAd"
      placeholder="Ürün adı"
    >
  </template>
  <template v-else>
    {{ row.stokAd || row.stokKod }}
  </template>
</div>

      <div class="offer-row-qty">
        <input
          type="number"
          min="0"
          step="0.01"
          v-model.number="row.miktar"
        />
      </div>
    </div>

    <!-- 2. SATIR: Kod + Birim + Liste Fiyat -->
<div class="offer-row-mid">
  <div class="offer-row-code">
    <template v-if="row.manual">
      <input
        type="text"
        v-model="row.stokKod"
        placeholder="Kod"
      >
    </template>
    <template v-else>
      {{ row.stokKod }}
    </template>
  </div>

<div class="offer-row-unit">
  <template v-if="row.manual">
    <select
      v-model="row.birim"
      class="mobile-select"
    >
      <option
        v-for="u in unitOptions"
        :key="'m-unit-' + u"
        :value="u"
      >
        {{ u }}
      </option>
    </select>
  </template>

  <template v-else>
    {{ row.birim }}
  </template>
</div>


  <div class="offer-row-list">
    <template v-if="row.manual">
      <input
        type="number"
        min="0"
        step="0.01"
        v-model.number="row.listeFiyat"
      >
    </template>
    <template v-else>
      {{ formatCurrency(row.listeFiyat, 'TL') }}
    </template>
  </div>
</div>


    <!-- 3. SATIR: İskontolar + KDV -->
    <div class="offer-row-disc">
      <div v-if="iskontoConfig.show1" class="disc-item">
        <select
          v-model.number="row.isk1"
          @change="onIskontoChange(row, 'isk1')"
        >
          <option v-for="i in iskontoOptions1" :key="'m-i1-' + i" :value="i">
            {{ i }}
          </option>
        </select>
      </div>
      <div v-if="iskontoConfig.show2" class="disc-item">
        <select
          v-model.number="row.isk2"
          @change="onIskontoChange(row, 'isk2')"
        >
          <option v-for="i in iskontoOptions2" :key="'m-i2-' + i" :value="i">
            {{ i }}
          </option>
        </select>
      </div>
      <div v-if="iskontoConfig.show3" class="disc-item">
        <select
          v-model.number="row.isk3"
          @change="onIskontoChange(row, 'isk3')"
        >
          <option v-for="i in iskontoOptions3" :key="'m-i3-' + i" :value="i">
            {{ i }}
          </option>
        </select>
      </div>
<div class="disc-kdv">
  <template v-if="row.manual">
    <input
      type="number"
      min="0"
      max="100"
      step="1"
      v-model.number="row.kdv"
    />
    <span>%</span>
  </template>
  <template v-else>
    <span style="font-size:12px;">
      KDV: {{ row.kdv }}%
    </span>
  </template>
</div>

    </div>

    <!-- ALT SATIR: Net TL | Net USD | İşlemler -->
    <div class="offer-row-bottom">
      <div class="bottom-tl">
        {{ formatCurrency(satirHesapla(row).genelSatirTutar, 'TL') }}
      </div>
      <div class="bottom-usd">
        {{ formatCurrency(satirHesapla(row).usdNet, 'USD') }}
      </div>
      <div class="bottom-actions">
        <button class="btn-icon" @click="copyRow(index)" title="Kopyala">⧉</button>
        <button class="btn-icon danger" @click="removeRow(index)" title="Sil">×</button>
      </div>
    </div>
  </div>

  <div v-if="form.kalemler.length === 0" class="mobile-empty">
    Henüz satır yok. Ürün arayarak satır ekleyin.
  </div>
</div>
        <!-- AÇIKLAMA -->
        <div class="card note-card soft-card">
          <div class="card-body">
            <label
              style="font-size: 12px; font-weight: 500; color: #777; display:block; margin-bottom:4px;"
            >
              Açıklama
            </label>
            <textarea
              v-model="form.aciklama"
              placeholder="Teklif ile ilgili genel açıklamalar, özel notlar, teslim detayları..."
            ></textarea>
          </div>
        </div>
      </div>

      <!-- SAĞ TARAF: TEKLİF ÖZETİ -->
      <div class="main-right">
        <div class="card summary-card soft-card">
          <div class="card-body">
            <div class="summary-title">Teklif Özeti</div>

            <ul class="summary-list">
              <li class="summary-item">
                <span class="summary-item-label">TOPLAM (Liste)</span>
                <span class="summary-item-value">
                  {{ formatCurrency(toplamListeTutar) }}
                </span>
              </li>
              <li class="summary-item summary-item-discount">
                <span class="summary-item-label">İSKONTO</span>
                <span class="summary-item-value negative">
                  - {{ formatCurrency(toplamIskontoTutar) }}
                </span>
              </li>
              <li class="summary-item">
                <span class="summary-item-label">ARA TUTAR (KDV hariç)</span>
                <span class="summary-item-value">
                  {{ formatCurrency(araTutar) }}
                </span>
              </li>
<!-- KDV oranlarına göre detay -->
<li
  v-for="kdv in kdvBreakdown"
  :key="'kdv-' + kdv.rate"
  class="summary-item"
>
  <span class="summary-item-label">
    KDV (%{{ kdv.rate }})
  </span>
  <span class="summary-item-value">
    {{ formatCurrency(kdv.tutar) }}
  </span>
</li>

<!-- İstersen genel KDV toplamı da kalsın -->
<li class="summary-item">
  <span class="summary-item-label">TOPLAM KDV</span>
  <span class="summary-item-value">
    {{ formatCurrency(toplamKdvTutar) }}
  </span>
</li>

              <li class="summary-item">
                <span class="summary-item-label">TUTAR (TL) Genel</span>
                <span class="summary-item-value total">
                  {{ formatCurrency(genelTutar) }}
                </span>
              </li>
              <li class="summary-item">
                <span class="summary-item-label">TUTAR (USD) Genel</span>
                <span class="summary-item-value">
                  {{ formatCurrency(genelTutarUsd, 'USD') }}
                </span>
              </li>
              <li class="summary-item">
                <span class="summary-item-label">TUTAR (EUR) Genel</span>
                <span class="summary-item-value">
                  {{ formatCurrency(genelTutarEur, 'EUR') }}
                </span>
              </li>
            </ul>

<div class="summary-actions">
  <button class="btn btn-ghost btn-block" @click="saveDraft">
    Teklifi Kaydet
  </button>
  <button class="btn btn-main btn-block" @click="saveAndSend">
    Teklifi Kayıt Et &amp; Gönder
  </button>
  <button class="btn btn-success btn-block" @click="addToOrder">
    Siparişe Ekle
  </button>
  <button class="btn btn-warning btn-block" @click="previewPdf">
    Önizle (PDF)
  </button>
</div>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import db from '../../db';              // 🔥 sepet.vue’deki gibi
// import fiyatHelper vs. şimdilik gerek yok, iskontoları burada yönetiyoruz

// ÖRNEK: oturum açan kullanıcının iskonto zinciri
// Bunu ileride this.$store.aktifCari.iskontoZinciri vb. ile değiştirebilirsin.
import { JOST_REGULAR} from '@/static/pdf-font.js';


const KULLANICI_ISKONTO_ZINCIRI = '30+20+5';

let globalRowId = 1;

export default {
  name: 'TeklifForm',
  data() {
    const [max1, max2, max3] = KULLANICI_ISKONTO_ZINCIRI
      .split('+')
      .map(v => Number(v) || 0);

    const iskontoConfig = {
      max1,
      max2,
      max3,
      show1: max1 > 0,
      show2: max2 > 0,
      show3: max3 > 0
    };

    const today = new Date().toISOString().substr(0, 10);

    return {
      hesap:this.$request.ayar(),
      form: {
        tarih: today,
        odemeSekli: '',
        teslimSekli: '',
        gecerlilikTarih: today,
        teklifNo: '',
        aciklama: '',
        kalemler: []
      },

      odemeSekliOptions: [
        { value: 'NAKIT', label: 'Nakit' },
        { value: 'HAVALE', label: 'Havale / EFT' },
        { value: 'KREDI_KARTI', label: 'Kredi Kartı' },
        { value: 'VADELI', label: 'Vadeli' }
      ],
      teslimSekliOptions: [
        { value: 'FABRIKA', label: 'Fabrika Teslim' },
        { value: 'ADRESE', label: 'Adrese Teslim' },
        { value: 'KARGO', label: 'Kargo ile Gönderim' }
      ],
      unitOptions: ['AD', 'DZ', 'TK', 'MT', 'YIL'],
      iskontoConfig,

      usdKuru: 33.5,
      eurKuru: 36.2,

      // ürün arama
      productSearch: '',
      searchResults: [],
      searching: false,
      dropdownFocused: false
    };
  },
  computed: {
    showProductDropdown() {
      return (
        this.productSearch.length >= 2 &&
        (this.searching || this.searchResults.length > 0) &&
        this.dropdownFocused
      );
    },

    iskontoOptions1() {
      return this.rangeOptions(0, this.iskontoConfig.max1);
    },
    iskontoOptions2() {
      return this.rangeOptions(0, this.iskontoConfig.max2);
    },
    iskontoOptions3() {
      return this.rangeOptions(0, this.iskontoConfig.max3);
    },

    toplamListeTutar() {
      return this.form.kalemler.reduce((sum, r) => sum + this.satirListeTutar(r), 0);
    },
    toplamIskontoTutar() {
      return this.form.kalemler.reduce((sum, r) => sum + this.satirHesapla(r).toplamIskonto, 0);
    },
    araTutar() {
      return this.form.kalemler.reduce((sum, r) => sum + this.satirHesapla(r).netKdvHaric, 0);
    },
    toplamKdvTutar() {
      return this.form.kalemler.reduce((sum, r) => sum + this.satirHesapla(r).kdvTutar, 0);
    },
    genelTutar() {
      return this.araTutar + this.toplamKdvTutar;
    },

    genelTutarUsd() {
      if (!this.usdKuru || this.usdKuru <= 0) return 0;
      return this.genelTutar / this.usdKuru;
    },
    genelTutarEur() {
      if (!this.eurKuru || this.eurKuru <= 0) return 0;
      return this.genelTutar / this.eurKuru;
    },
 toplamKdvTutar() {
    // İstersen toplamı hala kullanabiliriz
    return this.kdvBreakdown.reduce((sum, k) => sum + k.tutar, 0);
  },

  // 🔥 Yeni: KDV oranına göre detay
  kdvBreakdown() {
    const map = {}; // { '8': 52, '20': 100, ... }

    this.form.kalemler.forEach(r => {
      const hesap = this.satirHesapla(r); // içinde kdvTutar var
      const rate = Number(r.kdv) || 0;
      if (!map[rate]) map[rate] = 0;
      map[rate] += hesap.kdvTutar;
    });

    // [{ rate: 8, tutar: 52 }, { rate: 20, tutar: 100 }] gibi array çevir
    return Object.keys(map)
      .map(k => ({
        rate: Number(k),
        tutar: map[k]
      }))
      .sort((a, b) => a.rate - b.rate);
  },

  genelTutar() {
    return this.araTutar + this.toplamKdvTutar;
  },
    usdKuruText() {
      return this.usdKuru ? this.usdKuru.toFixed(4) : '-';
    },
    eurKuruText() {
      return this.eurKuru ? this.eurKuru.toFixed(4) : '-';
    },
    
  },
  async created() {
  this.$store.setLoading([false,''])},
  methods: {
    rangeOptions(min, max) {
      const arr = [];
      for (let i = min; i <= max; i++) arr.push(i);
      return arr;
    },

    // 🔍 ÜRÜN ARAMA – IndexDB (Dexie) entegrasyonu
    onProductSearchFocus() {
      this.dropdownFocused = true;
    },
    onProductSearchBlur() {
      setTimeout(() => {
        this.dropdownFocused = false;
      }, 150);
    },

    async onProductSearchChange() {
      const q = this.productSearch.trim();
      if (q.length < 2) {
        this.searchResults = [];
        return;
      }

      this.searching = true;
      try {
        const qLower = q.toLowerCase();

        // 1) Eğer isim üzerinde indexin varsa:
        // let results = await db.stocks
        //   .where('isimLower')        // senin tanımladığın index alanı
        //   .startsWith(qLower)
        //   .limit(30)
        //   .toArray();

        // 2) Genel fallback (sepet.vue’deki gibi toCollection().filter):
        let results = await db.stocks
          .toCollection()
          .filter(s => {
            const isim = (s.isim || '').toLowerCase();
            const kod = (s.kod || '').toLowerCase();
            return isim.includes(qLower) || kod.includes(qLower);
          })
          .limit(30)
          .toArray();

        this.searchResults = results;
      } catch (err) {
        console.error('Ürün arama hatası:', err);
        this.searchResults = [];
      } finally {
        this.searching = false;
      }
    },

    selectProduct(stok) {
      this.addRowFromStock(stok);
      this.productSearch = '';
      this.searchResults = [];
    },

    // 🧾 Satıra stok ekleme (kod / isim / birim / liste fiyat text olacak)
addRowFromStock(stok) {
  const listeFiyat = Number(
    stok.fiyat != null ? stok.fiyat : stok.listeFiyat
  ) || 0;

  const row = {
    id: globalRowId++,
    manual: false,                // 🔥 stoktan geliyor, kilitli alanlar
    stokKod: stok.kod,
    stokAd: stok.isim,
    miktar: 1,
    birim: stok.birim || 'AD',
    listeFiyat: listeFiyat,
    isk1: this.iskontoConfig.show1 ? this.iskontoConfig.max1 : 0,
    isk2: this.iskontoConfig.show2 ? this.iskontoConfig.max2 : 0,
    isk3: this.iskontoConfig.show3 ? this.iskontoConfig.max3 : 0,
    kdv: Number(stok.kdv) || 20
  };

  this.form.kalemler.push(row);
},
addEmptyRow() {
    const row = {
      id: globalRowId++,
      manual: true,           // 🔥 manuel satır
      stokKod: '',
      stokAd: '',
      miktar: 1,
      birim: 'AD',
      listeFiyat: 0,
      isk1: 0,
      isk2: 0,
      isk3: 0,
      kdv: 20
    };
    this.form.kalemler.push(row);
  },

    copyRow(index) {
      const r = this.form.kalemler[index];
      const copy = JSON.parse(JSON.stringify(r));
      copy.id = globalRowId++;
      this.form.kalemler.splice(index + 1, 0, copy);
    },

    removeRow(index) {
      this.form.kalemler.splice(index, 1);
    },

    // 🎯 İskonto davranışı (senin tarif ettiğin reset mantığı)
    onIskontoChange(row, field) {
      const v1 = Number(row.isk1) || 0;
      const v2 = Number(row.isk2) || 0;
      const v3 = Number(row.isk3) || 0;

      if (field === 'isk1' && v1 === 0) {
        row.isk2 = 0;
        row.isk3 = 0;
        return;
      }

      if (field === 'isk2' && v2 === 0) {
        row.isk3 = 0;
        return;
      }

      if (v1 === 0) {
        row.isk2 = 0;
        row.isk3 = 0;
      } else if (v2 === 0) {
        row.isk3 = 0;
      }
    },

    // 💰 Hesaplama
    satirListeTutar(row) {
      const miktar = Number(row.miktar) || 0;
      const fiyat = Number(row.listeFiyat) || 0;
      return miktar * fiyat;
    },

    satirHesapla(row) {
      const listeTutar = this.satirListeTutar(row);

      const isk1 = this.iskontoConfig.show1 ? (Number(row.isk1) || 0) : 0;
      const isk2 = this.iskontoConfig.show2 ? (Number(row.isk2) || 0) : 0;
      const isk3 = this.iskontoConfig.show3 ? (Number(row.isk3) || 0) : 0;
      const kdvYuzde = Number(row.kdv) || 0;

      const isk1Tutar = listeTutar * (isk1 / 100);
      const kalan1 = listeTutar - isk1Tutar;

      const isk2Tutar = kalan1 * (isk2 / 100);
      const kalan2 = kalan1 - isk2Tutar;

      const isk3Tutar = kalan2 * (isk3 / 100);
      const netKdvHaric = kalan2 - isk3Tutar;

      const kdvTutar = netKdvHaric * (kdvYuzde / 100);
      const genelSatirTutar = netKdvHaric + kdvTutar;
let usd = 0;
  if (this.usdKuru && this.usdKuru > 0) {
    usd = genelSatirTutar / this.usdKuru;
  }
      return {
        listeTutar,
        isk1Tutar,
        isk2Tutar,
        isk3Tutar,
        toplamIskonto: isk1Tutar + isk2Tutar + isk3Tutar,
        netKdvHaric,
        kdvTutar,
        genelSatirTutar,
        usdNet: usd // 👈 EKLENDİ

      };
    },

    satirNetToplam(row) {
      return this.satirHesapla(row).genelSatirTutar;
    },

    formatCurrency(value, currency = 'TL') {
      const n = Number(value) || 0;
      const s = n.toFixed(2);
      if (currency === 'USD') return s + ' $';
      if (currency === 'EUR') return s + ' €';
      return s + ' ₺';
    },

    buildPayload() {
      return {
        ...this.form,
        ozet: {
          toplamListeTutar: this.toplamListeTutar,
          toplamIskontoTutar: this.toplamIskontoTutar,
          araTutar: this.araTutar,
          toplamKdvTutar: this.toplamKdvTutar,
          genelTutarTl: this.genelTutar,
          usdKuru: this.usdKuru,
          eurKuru: this.eurKuru,
          genelTutarUsd: this.genelTutarUsd,
          genelTutarEur: this.genelTutarEur
        }
      };
    },

    // BUTONLAR
    saveDraft() {
      const payload = this.buildPayload();
      console.log('Taslak teklif kaydet payload:', payload);
      this.$swal({
        title: "Onaylıyor musunuz?",
        text: "Teklif yönetim onayına gidecek",
        icon: "warning",
        //showCancelButton: true,
        confirmButtonText: "Evet",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
    this.$store.setLoading([true,'Bekleyiniz'])

          this.$request.post("crm/teklif/add", {teklif:payload,cari:this.$store.aktifCari}).then((response) => {
              let bildirimObje = {
                tip:2,
                alias:'Teklif',
                renk:'info',
                link:'teklif',
                seri:"T",
                sira:response.id,
                baslik:this.$store.aktifCari.unvan,
                ckod:this.$store.aktifCari.kod,
                names:this.hesap.kad// sadece mail için
              }
              this.$request.post("crm/bildirim/add", bildirimObje,this.hesap)
              setTimeout(() => {
    this.$store.setLoading([false,''])

                  this.$swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: "Teklif Onaya Gönderildi",
                  showConfirmButton: false,
                  timer: 2000,
                });
              }, 1000);
            })
        }
      })

    },
    saveAndSend() {
      if (!this.form.kalemler.length) {
        alert('En az bir satır eklemelisiniz.');
        return;
      }
      const payload = this.buildPayload();
      console.log('Teklifi Kayıt Et & Gönder payload:', payload);
    },
    addToOrder() {
      const payload = this.buildPayload();
      console.log('Teklifi siparişe dönüştür payload:', payload);
    },
previewPdf () {
  // jsPDF CDN yüklü mü kontrol et
  if (!window.jspdf || !window.jspdf.jsPDF) {
    alert('PDF modülü (jsPDF) yüklenemedi. Lütfen sayfayı yenileyin.');
    return;
  }

  var jsPDF = window.jspdf.jsPDF;
  var doc = new jsPDF('p', 'mm', 'a4');

  var teklif = this.buildPayload();    
  var ozet = teklif.ozet || {};
  var kdvDetay = Array.isArray(teklif.kdvDetay) ? teklif.kdvDetay : [];

  var yetkili = teklif.yetkiliAd || teklif.hazirlayan || '';
  var surum = teklif.surum || teklif.version || 'v1.0';

  var pageWidth = doc.internal.pageSize.getWidth();
  var marginLeft = 15;
  var marginRight = 15;
  var cursorY = 5;

  // =============== 1) EN ÜST: SOL LOGO, SAĞ EGEM BİLGİLERİ ===============

  // LOGO (opsiyonel)
  if (this.logoBase64) {
    try {
      doc.addImage(this.logoBase64, 'PNG', marginLeft, cursorY - 3, 30, 12);
    } catch (e) {
      console.error('Logo eklenemedi:', e);
    }
  }

  // Sağ tarafa kendi firma bilgilerin
  var egemX = pageWidth - marginRight;

  // Font tanımları
  doc.addFileToVFS('Jost-Regular.ttf', JOST_REGULAR);
  doc.addFont('Jost-Regular.ttf', 'Jost', 'normal');
  doc.setFont('Jost', 'normal');

  doc.setFontSize(11);
  doc.setTextColor(0, 0, 0);
  doc.text('EGEM YAZILIM LTD. ŞTİ.', egemX, cursorY + 5, { align: 'right' });

  doc.setFontSize(8);
  doc.setTextColor(90);
  doc.text('Örnek Mah. Yazılım Cd. No:1 İzmir / Türkiye', egemX, cursorY + 9, { align: 'right' });
  doc.text('Tel: 0 (232) 000 00 00', egemX, cursorY + 13, { align: 'right' });
  doc.text('E-posta: info@egemyazilim.com', egemX, cursorY + 17, { align: 'right' });
  // doc.text('Hazırlayan: ' + this.hesap.isim, egemX, cursorY + 21, { align: 'right' });

  cursorY += 28;

  // =============== 2) ALT SATIR: SOL CARI, SAĞ TEKLİF KUTUSU ===============

  var cari = this.$store.aktifCari;
  var cariBoxX = marginLeft;
  var cariBoxY = cursorY;
  var cariBoxW = 110;
  var cariBoxH = 30;

  var teklifBoxX = cariBoxX + cariBoxW + 5;
  var teklifBoxY = cariBoxY;
  var teklifBoxW = pageWidth - marginLeft - teklifBoxX;
  var teklifBoxH = 30;

  // Cari kutusu
  doc.setDrawColor(210);
  doc.roundedRect(cariBoxX, cariBoxY, cariBoxW, cariBoxH, 2, 2);

  doc.setFontSize(9);
  doc.setTextColor(0);
  doc.text('MÜŞTERİ BİLGİLERİ', cariBoxX + 3, cariBoxY + 6);

  var cariY = cariBoxY + 11;
  doc.setFontSize(8);
  doc.setTextColor(60);

  doc.text('Cari : ' + cari.unvan, cariBoxX + 3, cariY);
  doc.text('Kod  : ' + cari.kod, cariBoxX + 3, cariY + 4);
  doc.text('Vergi Dairesi : ' + cari.vd, cariBoxX + 3, cariY + 12);
  doc.text('Vergi No  : ' + cari.vno, cariBoxX + 3, cariY + 16);
  doc.text('Adres: ' + cari.adres[0].bolge, cariBoxX + 3, cariY + 8, { maxWidth: cariBoxW - 6 });

  // Teklif kutusu (sağda)
  doc.setDrawColor(37, 99, 235);
  doc.roundedRect(teklifBoxX, teklifBoxY, teklifBoxW, teklifBoxH, 2, 2);

  doc.setFontSize(10);
  doc.setTextColor(37, 99, 235);
  doc.text('TEKLİF BİLGİLERİ NO :' + teklif.teklifNo, teklifBoxX + 3, teklifBoxY + 6);

  doc.setFontSize(9);
  doc.setTextColor(30);

  var tarihSatir = teklif.tarih + '  -  Geçerlilik : ' + teklif.gecerlilikTarih;
  var usdKuru = Number(ozet.usdKuru || 0);
  var eurKuru = Number(ozet.eurKuru || 0);

  var ty = teklifBoxY + 8;
  doc.text('Tarih : ' + tarihSatir, teklifBoxX + 3, ty + 4);
  doc.text('Ödeme Şekli : ' + teklif.odemeSekli, teklifBoxX + 3, ty + 9);
  doc.text('Teslim Şekli : ' + teklif.teslimSekli, teklifBoxX + 3, ty + 14);

  var kurStr = '';
  if (usdKuru > 0) {
    kurStr += 'USD ' + this.formatNumberPlain(usdKuru);
  }
  if (eurKuru > 0) {
    if (kurStr !== '') kurStr += '   ';
    kurStr += 'EUR ' + this.formatNumberPlain(eurKuru);
  }
  if (kurStr !== '') {
    doc.setFontSize(7);
    doc.setTextColor(80);
    doc.text('Kur: ' + kurStr, teklifBoxX + 3, ty + 20);
  }

  cursorY = cariBoxY + cariBoxH + 2;

  // =============== 3) ÜRÜN TABLOSU (stok vs manuel ayrımı) ===============

  var columns = [
    { header: 'Kod', dataKey: 'kod' },
    { header: 'Ürün', dataKey: 'ad' },
    { header: 'Adet', dataKey: 'miktar' },
    { header: 'Br.', dataKey: 'birim' },
    { header: 'Liste', dataKey: 'liste' },
    { header: 'Iskonto (%)', dataKey: 'isk' },
    { header: 'KDV', dataKey: 'kdv' },
    { header: 'Net (TL)', dataKey: 'netTl' },
    { header: 'Net (USD)', dataKey: 'netUsd' }
  ];

  var body = [];
  var i;

  for (i = 0; i < teklif.kalemler.length; i++) {
    var r = teklif.kalemler[i];
    var hesap = this.satirHesapla(r);

    var iskStr = '' + (r.isk1 || 0);
    if (this.iskontoConfig && this.iskontoConfig.show2) iskStr += '/' + (r.isk2 || 0);
    if (this.iskontoConfig && this.iskontoConfig.show3) iskStr += '/' + (r.isk3 || 0);

    var usdSatir = 0;
    if (usdKuru > 0) {
      usdSatir = hesap.genelSatirTutar / usdKuru;
    }

    var adText = r.stokAd || '';
    if (r.manual === true) {
      adText = '* ' + (adText || 'MANUEL SATIR');
    }

    body.push({
      kod: r.stokKod || '',
      ad: adText,
      miktar: this.formatNumberPlain(r.miktar || 0),
      birim: r.birim || '',
      liste: this.formatNumberPlain(r.listeFiyat || 0),
      isk: iskStr,
      kdv: (r.kdv || 0) + '%',
      netTl: this.formatNumberPlain(hesap.genelSatirTutar),
      netUsd: this.formatNumberPlain(usdSatir)
    });
  }

  doc.setFontSize(10);
  doc.setTextColor(20);

  var headRow = [];
  for (i = 0; i < columns.length; i++) {
    headRow.push(columns[i].header);
  }

  var bodyRows = [];
  for (i = 0; i < body.length; i++) {
    var rowObj = body[i];
    var rowArr = [];
    var j;
    for (j = 0; j < columns.length; j++) {
      rowArr.push(rowObj[columns[j].dataKey]);
    }
    bodyRows.push(rowArr);
  }

  var self = this;

  doc.autoTable({
    startY: cursorY + 4,
    head: [headRow],
    body: bodyRows,
    styles: { fontSize: 7, cellPadding: 1.4 },
    headStyles: { fillColor: [240, 240, 240], textColor: 20 },
    columnStyles: {
      0: { cellWidth: 21 },
      1: { cellWidth: 77 },
      2: { cellWidth: 10, halign: 'right' },
      3: { cellWidth: 10 },
      4: { cellWidth: 16, halign: 'right' },
      5: { cellWidth: 16, halign: 'right' }, // iskonto
      6: { cellWidth: 10, halign: 'right' },
      7: { cellWidth: 16, halign: 'right' },
      8: { cellWidth: 14, halign: 'right' }
    },
    margin: { left: marginLeft },
    theme: 'grid',
    didParseCell: function (data) {
      if (data.section === 'body') {
        var idx = data.row.index;
        var rowOrig = teklif.kalemler[idx];
        if (rowOrig && rowOrig.manual === true) {
          data.cell.styles.fillColor = [248, 250, 252];
          data.cell.styles.fontStyle = 'italic';
        }
      }
    }
  });

  var afterTableY = doc.lastAutoTable.finalY + 7;

  // =============== 4) ÖZET BÖLÜMÜ – KDV ORANLARI AYRI ===============

  var sumX       = 120;
  var ySum       = afterTableY;
  var lineHeight = 5;

  // yardımc
  var addSummaryLine = function (label, value, isDiscount, pb) {
    if (typeof value !== 'number') {
      value = Number(value) || 0;
    }

    var labelColor = isDiscount ? [185, 28, 28] : [110, 110, 110];
    var valueColor = isDiscount ? [185, 28, 28] : [20, 20, 20];

    doc.setFont('Jost', 'normal');
    doc.setFontSize(9);
    doc.setTextColor(labelColor[0], labelColor[1], labelColor[2]);
    doc.text(label, sumX, ySum);

    var formatted = self.formatNumberPlain(value) + ' '+pb;

    doc.setFont('Jost', 'normal');
    doc.setTextColor(valueColor[0], valueColor[1], valueColor[2]);
    doc.text(formatted, sumX + 70, ySum, { align: 'right' });

    ySum += lineHeight;
  };

  // Ekrandaki 3 temel satır
  addSummaryLine('TOPLAM (Liste)', ozet.toplamListeTutar, false , 'TL');
  addSummaryLine('İSKONTO',        ozet.toplamIskontoTutar, true,'TL');
  addSummaryLine('ARA TUTAR',      ozet.araTutar, false,'TL');

  // KDV oranlarına göre satırlar
// 2) KDV oranlarını satırlardan gruplandır
var kdvGruplu = {};   // örn: { '20': 123.45, '8': 56.78 }
var toplamKdv = 0;

for (i = 0; i < teklif.kalemler.length; i++) {
  var row = teklif.kalemler[i];
  var oran = Number(row.kdv || 0);
  if (!oran) continue;

  var hesapSatir = this.satirHesapla(row);

  // satır toplamı (KDV dahil)
  var satirToplam = Number(hesapSatir.genelSatirTutar || 0);

  // satır KDV tutarı:
  var satirKdv = 0;

  if (typeof hesapSatir.kdvTutar === 'number') {
    // satirHesapla zaten KDV tutarını veriyorsa direkt kullan
    satirKdv = Number(hesapSatir.kdvTutar || 0);
  } else if (oran > 0) {
    // aksi halde yaklaşık olarak toplamdan neti ayır
    satirKdv = satirToplam - (satirToplam / (1 + oran / 100));
  }

  if (!kdvGruplu[oran]) {
    kdvGruplu[oran] = 0;
  }
  kdvGruplu[oran] += satirKdv;
}

// 3) Eğer satırlardan bir şey çıkmadıysa, eski toplamKdv'yı kullan
var oranlar = Object.keys(kdvGruplu);
if (oranlar.length > 0) {
  // küçükten büyüğe sırala
  oranlar.sort(function (a, b) { return Number(a) - Number(b); });

  toplamKdv = 0;
  for (var oi = 0; oi < oranlar.length; oi++) {
    var o = oranlar[oi];
    var tutar = kdvGruplu[o];
    toplamKdv += tutar;
    addSummaryLine('KDV (%' + o + ')', tutar, false , 'TL');
  }
} else {
  toplamKdv = Number(ozet.toplamKdvTutar || 0);
}


  var usd = Number(ozet.genelTutarUsd || 0);
  var eur = Number(ozet.genelTutarEur || 0);

  addSummaryLine('TOPLAM KDV', toplamKdv, false,'TL');
  addSummaryLine('GENEL TOPLAM (TL)', ozet.genelTutarTl, false,'TL');
  addSummaryLine('GENEL TOPLAM (USD)',usd ,false,'USD');
  addSummaryLine('GENEL TOPLAM (EUR)',eur ,false,'EUR');

  // Alt satır: USD / EUR bilgisi (tek satır)
 
  // =============== 5) AÇIKLAMA + İMZA ===============

  var noteStart = afterTableY;
  if (noteStart < ySum + 20) {
    noteStart = ySum + 15;
  }

  if (teklif.aciklama) {
    doc.setTextColor(30);
    doc.setFontSize(9);
    doc.text('Açıklama', marginLeft, noteStart);

    doc.setFontSize(8);
    doc.setTextColor(80);
    doc.text(teklif.aciklama, marginLeft, noteStart + 5, { maxWidth: 180 });
  }

  var signY = 285;
  doc.setFontSize(8);
  doc.setTextColor(20);
  doc.text('Teklifi Hazırlayan:' + this.hesap.isim, marginLeft, signY);

  doc.setDrawColor(150);
  doc.line(marginLeft + 38, signY + 1, marginLeft + 90, signY + 1);

  if (yetkili) {
    doc.setFontSize(8);
    doc.setTextColor(40);
    doc.text(yetkili, marginLeft + 59, signY + 5, { align: 'center' });
  } else {
    doc.setFontSize(7);
    doc.setTextColor(120);
    doc.text('İmza / Kaşe', marginLeft + 59, signY + 5, { align: 'center' });
  }

  // =============== 6) ÖNİZLEME ===============
  var blobUrl = doc.output('bloburl');
  window.open(blobUrl, '_blank');
},



  // Yardımcı: 1.234,56 formatı için
  formatNumberPlain(value) {
    const n = Number(value) || 0;
    return n
      .toFixed(2)
      .replace('.', ',')
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');      
    }
  }
};
</script>


<style scoped>
  .page {
  width: 100%;
  padding: 16px;
}

/* Soft card: üst form, arama, tablo, açıklama, sağ özet */
.soft-card {
  background: #f9fafb; /* beyazdan belirgin gri */
  border-radius: 10px;
  border: 1px solid #d1d5db;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.06);
}

/* Başlık barını da biraz ayır */
.page-header.soft-card {
  padding: 10px 16px;
}

/* Tablo wrapper zaten soft-card, ek olarak üst kenar */
.table-wrapper.soft-card {
  padding-top: 4px;
}

/* Satır içi text */
.cell-text {
  font-size: 11px;
  color: #111827;
}

/* Mevcut btn tabanını bozmadan, varyantları renklendiriyoruz */
.btn {
  border-radius: 999px;
  border: 1px solid transparent;
  padding: 6px 14px;
  font-size: 12px;
  cursor: pointer;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, box-shadow 0.15s, transform 0.05s, color 0.15s, border-color 0.15s;
}

/* Ana (mavi) buton */
.btn-main {
  background: #2563eb;
  border-color: #2563eb;
  color: #ffffff;
}
.btn-main:hover {
  background: #1d4ed8;
  border-color: #1d4ed8;
  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.5);
}

/* Yeşil buton (Siparişe Ekle) */
.btn-success {
  background: #16a34a;
  border-color: #16a34a;
  color: #ffffff;
}
.btn-success:hover {
  background: #15803d;
  border-color: #15803d;
  box-shadow: 0 6px 16px rgba(22, 163, 74, 0.5);
}

/* Turuncu buton (Önizle PDF) */
.btn-warning {
  background: #f97316;
  border-color: #f97316;
  color: #111827;
}
.btn-warning:hover {
  background: #ea580c;
  border-color: #ea580c;
  color: #111827;
  box-shadow: 0 6px 16px rgba(249, 115, 22, 0.5);
}

/* Gri hayalet buton (Kaydet) */
.btn-ghost {
  background: #ffffff;
  border-color: #d1d5db;
  color: #4b5563;
}
.btn-ghost:hover {
  background: #f3f4f6;
  border-color: #9ca3af;
}

/* İSKONTO satırını daha belirgin kırmızı yap */
.summary-item-discount {
  background: #fef2f2; /* pembe arka plan */
  border-left: 3px solid #dc2626;
}
.summary-item-discount .summary-item-label {
  color: #b91c1c;
  font-weight: 600;
}
.summary-item-discount .summary-item-value.negative {
  color: #b91c1c;
  font-weight: 700;
}
  .soft-card {
  background: #fdfefe;
  border-color: #e5e7eb;
}

.cell-text {
  font-size: 11px;
  color: #374151;
}

/* İskonto daha kırmızı dursun */
.summary-item-value.negative {
  color: #dc2626;
  font-weight: 700;
}


    .page-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      padding: 4px 2px;
    }

    .page-title {
      font-size: 22px;
      font-weight: 600;
    }

    .page-subtitle {
      font-size: 13px;
      color: var(--text-muted);
    }

    .card {
      background: var(--bg-card);
      border-radius: var(--radius-card);
      border: 1px solid var(--border-soft);
      box-shadow: var(--shadow-soft);
      margin-bottom: 16px;
    }

    .card-body {
      padding: 14px 16px;
    }

    /* GENEL BİLGİLER FORMU */
    .form-row {
      display: flex;
      flex-wrap: wrap;
      margin: -8px;
    }

    .form-group {
      padding: 8px;
      flex: 0 0 20%; /* 5 sütun */
      min-width: 200px;
    }

    .form-group label {
      display: block;
      font-size: 12px;
      font-weight: 500;
      margin-bottom: 4px;
      color: var(--text-muted);
    }

    .form-control {
      width: 100%;
      border-radius: var(--radius-input);
      border: 1px solid var(--border-soft);
      padding: 6px 10px;
      font-size: 13px;
      outline: none;
      transition: border-color 0.15s, box-shadow 0.15s;
      background-color: #fff;
    }

    .form-control:focus {
      border-color: var(--primary);
      box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.2);
    }

    /* Teklif No + Kur bilgisi aynı satırda */
    .form-group-header {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      margin-bottom: 4px;
      gap: 8px;
    }

    .form-group-header label {
      margin-bottom: 0;
    }

    .rates-inline {
      font-size: 11px;
      color: var(--text-muted);
      white-space: nowrap;
    }
    .rates-inline strong {
      color: var(--text-main);
      font-weight: 500;
    }

    /* ANA İÇERİK (SOL / SAĞ) */
    .main-layout {
      display: flex;
      align-items: stretch;
      gap: 16px;
    }

    .main-left {
      flex: 3;
      min-width: 0;
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .main-right {
      flex: 1;
      min-width: 260px;
    }

    /* ÜRÜN ARAMA */
    .search-wrapper {
      position: relative;
    }

    .search-label-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 4px;
    }

    .search-label-row span {
      font-size: 12px;
      color: var(--text-muted);
    }

    .search-input-row {
      display: flex;
      gap: 8px;
    }

    .search-input-row .form-control {
      flex: 1;
    }

    .btn {
      border-radius: 999px;
      border: 1px solid transparent;
      padding: 6px 14px;
      font-size: 12px;
      cursor: pointer;
      background: var(--primary);
      color: #fff;
      font-weight: 500;
      white-space: nowrap;
      transition: background 0.15s, box-shadow 0.15s, transform 0.05s;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .btn:hover {
      background: #1d4ed8;
      box-shadow: 0 4px 10px rgba(37, 99, 235, 0.4);
    }

    .btn:active {
      transform: translateY(1px);
      box-shadow: 0 2px 6px rgba(37, 99, 235, 0.4);
    }

    .btn-outline {
      background: #fff;
      color: var(--primary);
      border-color: var(--primary-soft);
    }

    .btn-outline:hover {
      background: var(--primary-soft);
    }

    .btn-sm {
      padding: 4px 10px;
      font-size: 11px;
    }

    /* DEMO DROPDOWN */
    .product-dropdown {
      position: absolute;
      left: 0;
      right: 0;
      top: 100%;
      margin-top: 4px;
      background: #fff;
      border-radius: 8px;
      box-shadow: var(--shadow-soft);
      border: 1px solid var(--border-soft);
      list-style: none;
      padding: 4px 0;
      max-height: 220px;
      overflow-y: auto;
      font-size: 13px;
      z-index: 20;
    }

    .product-dropdown li {
      padding: 6px 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
    }

    .product-dropdown li:hover {
      background: var(--primary-soft);
    }

    .product-dropdown .code {
      font-weight: 600;
      margin-right: 4px;
    }

    .product-dropdown .price {
      font-size: 12px;
      color: var(--text-muted);
    }

    /* TABLO */
    .table-wrapper {
      border-radius: var(--radius-card);
      border: 1px solid var(--border-soft);
      overflow: hidden;
      background: #fff;
      box-shadow: var(--shadow-soft);
    }

    table {
      width: 100%;
      border-collapse: collapse;
      font-size: 12px;
    }

    thead {
      background: #f9fafb;
    }

    th, td {
      padding: 6px 8px;
      border-bottom: 1px solid #edf0f5;
      text-align: left;
      vertical-align: middle;
      white-space: nowrap;
    }

    th {
      font-weight: 500;
      color: var(--text-muted);
    }

    tbody tr:last-child td {
      border-bottom: none;
    }

    .text-right {
      text-align: right;
    }

    .text-center {
      text-align: center;
    }

    .cell-input {
      width: 100%;
      border-radius: 4px;
      border: 1px solid #e1e4ec;
      padding: 4px 6px;
      font-size: 11px;
      outline: none;
    }

    .cell-input:focus {
      border-color: var(--primary);
      box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.15);
    }

    .cell-select {
      width: 100%;
      border-radius: 4px;
      border: 1px solid #e1e4ec;
      padding: 3px 4px;
      font-size: 11px;
      background: #fff;
      outline: none;
    }

    .row-actions {
      display: flex;
      gap: 4px;
      justify-content: center;
    }

    .btn-icon {
      border-radius: 999px;
      border: 1px solid #e1e4ec;
      background: #fff;
      width: 22px;
      height: 22px;
      font-size: 13px;
      padding: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: background 0.15s, border-color 0.15s;
    }

    .btn-icon:hover {
      background: #f3f4ff;
      border-color: var(--primary);
    }

    .btn-icon.danger:hover {
      background: #fee2e2;
      border-color: var(--danger);
      color: var(--danger);
    }

    .table-footer {
      padding: 6px 8px;
      display: flex;
      justify-content: flex-end;
      background: #f9fafb;
      border-top: 1px solid #edf0f5;
    }

    /* ÖZET KARTI */
    .summary-card .card-body {
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    .summary-title {
      font-size: 15px;
      font-weight: 600;
      margin-bottom: 10px;
    }

    .summary-list {
      list-style: none;
      margin: 0;
      padding: 0;
      border-radius: 8px;
      border: 1px solid #edf0f5;
      overflow: hidden;
      margin-bottom: 12px;
    }

    .summary-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 6px 10px;
      font-size: 13px;
      background: #fff;
    }

    .summary-item:nth-child(even) {
      background: #f9fafb;
    }

    .summary-item-label {
      color: var(--text-muted);
    }

    .summary-item-value {
      font-weight: 600;
    }

    .summary-item-value.negative {
      color: var(--danger);
    }

    .summary-item-value.total {
      color: var(--success);
      font-size: 14px;
    }

    .summary-actions {
      margin-top: auto;
      display: flex;
      flex-direction: column;
      gap: 6px;
    }

    .btn-block {
      width: 100%;
      justify-content: center;
      display: inline-flex;
      align-items: center;
      gap: 6px;
    }

    .btn-secondary {
      background: #fff;
      color: var(--success);
      border-color: #bbf7d0;
    }

    .btn-secondary:hover {
      background: #dcfce7;
    }

    .btn-gray {
      background: #fff;
      color: #4b5563;
      border-color: #e5e7eb;
    }

    .btn-gray:hover {
      background: #f3f4f6;
    }

    /* AÇIKLAMA TEXTAREA (SOLDA, SATIRLARIN ALTINDA) */
    .note-card textarea {
      width: 100%;
      border-radius: var(--radius-input);
      border: 1px solid var(--border-soft);
      padding: 8px 10px;
      font-size: 13px;
      resize: vertical;
      min-height: 80px;
      outline: none;
    }

    .note-card textarea:focus {
      border-color: var(--primary);
      box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.2);
    }

    /* RESPONSIVE */
    @media (max-width: 992px) {
      .main-layout {
        flex-direction: column;
      }
      .main-right {
        min-width: 0;
      }
      .form-group {
        flex: 0 0 33.333%;
      }
    }

    @media (max-width: 768px) {
      .page {
        padding: 10px;
      }
      .page-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
      }
      .form-group {
        flex: 0 0 50%;
      }
      .search-input-row {
        flex-direction: column;
      }
      .rates-inline {
        white-space: normal;
      }
    }

@media (max-width: 768px) {
  .form-row {
    display: flex;
    flex-wrap: wrap;
  }
  .form-group {
    flex: 0 0 50%; /* 2'li kolon, mobilde bile yan yana */
  }
}

    /* Sayfa arka planı koyulaştı */
/* Mobil satırları kart haline getir */
@media (max-width: 768px) {
  .table-wrapper table thead {
    display: none; /* başlık satırlarını gizle */
  }

  .table-wrapper table {
    border-collapse: separate;
    border-spacing: 0 8px; /* satırlar arası boşluk */
  }

  .table-wrapper table tbody tr {
    display: grid;
    grid-template-columns: 50px 1fr 70px; /* No | İsim | KDV */
    grid-template-areas:
      "cell-no   cell-name   cell-kdv"
      "cell-qty  cell-qty    cell-qty"
      "cell-unit cell-price  cell-price"
      "cell-isk1 cell-isk2   cell-isk3"
      "cell-nettl cell-netusd cell-actions";
    background: #ffffff;
    border-radius: 10px;
    padding: 6px 8px;
    border: 1px solid #e5e7eb;
  }

  /* Genel TD stilini azalt */
  .table-wrapper table tbody td {
    border-bottom: none;
    padding: 4px 4px;
  }

  /* Grid alan eşleştirme */
  td.cell-no       { grid-area: cell-no;       align-self: center; font-weight: 700; }
  td.cell-name     { grid-area: cell-name;     align-self: center; }
  td.cell-kdv      { grid-area: cell-kdv;      align-self: center; text-align:center; }

  td.cell-qty      { grid-area: cell-qty; }
  td.cell-unit     { grid-area: cell-unit; }
  td.cell-price    { grid-area: cell-price; text-align: right; }

  td.cell-isk1     { grid-area: cell-isk1; }
  td.cell-isk2     { grid-area: cell-isk2; }
  td.cell-isk3     { grid-area: cell-isk3; }

  td.cell-net-tl   { grid-area: cell-nettl; text-align: left; }
  td.cell-net-usd  { grid-area: cell-netusd; text-align: center; }
  td.cell-actions  { grid-area: cell-actions; text-align: right; }

  .cell-text {
    font-size: 12px;
  }

  .cell-input,
  .cell-select {
    font-size: 11px;
  }

  .row-actions {
    justify-content: flex-end;
  }
}


/* Kart görünümü TUTARLI */
.soft-card {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #d6dae1;
  box-shadow: 0 5px 18px rgba(0,0,0,0.06);
  padding: 12px !important;
}

/* Yukarıdaki soft-card template’te container bazlı olduğu için
   ek kapsayıcılara da uygulanacak */
.page-header,
.card,
.table-wrapper,
.note-card,
.summary-card {
  background: inherit;
}

.page-header {
  border-radius: 12px;
  border: 1px solid #d6dae1;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
  padding: 10px 16px;
}

/* Sol taraf her kartta net ayrışsın diye */
.card-body {
  padding: 8px 12px !important;
}

/* TABLOYU YERLE BİRAZ AYIRALIM */
.table-wrapper {
  background: #ffffff !important;
  border-radius: 12px;
  border: 1px solid #d1d5db;
  padding: 8px;
}

/* Açıklama alanı */
.note-card {
  padding: 8px !important;
}

/* Sağ taraf da belirginleşsin */
.summary-card {
  padding: 10px !important;
}

/* ÖZET BLOK AYIRICI */
.summary-list {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
}

/* Her satırda net ayrım */
.summary-item {
  background: #ffffff;
  padding: 7px 10px;
  border-bottom: 1px solid #e5e7eb;
}

.summary-item:last-child {
  border-bottom: none;
}

/* 🔥 İSKONTO burada artık kırmızı olarak belirgin */
.summary-item-discount {
  background: #ffeded !important;
  border-left: 4px solid #d60000;
}

.summary-item-discount .summary-item-label {
  color: #b50000;
  font-weight: 700;
}

.summary-item-discount .summary-item-value {
  color: #b50000 !important;
  font-weight: 800;
}

/* SATIR TEXT */
.cell-text {
  font-size: 12px;
  font-weight: 600;
  color: #111;
}

/* BUTON YENİ TASARIM */

/* Temel Buton Tipi */
.btn {
  border-radius: 999px;
  font-size: 13px;
  padding: 8px 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-width: 0;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease;
}

.btn-block {
  width: 100%;
}

/* 1️⃣ Ana işlem (Gönder) */
.btn-main {
  background: linear-gradient(to bottom right, #2563eb, #1e40af);
  color: #fff;
  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.45);
}
.btn-main:hover {
  transform: translateY(-1px);
}

/* 2️⃣ Siparişe ekleme yeşil */
.btn-success {
  background: linear-gradient(to bottom right, #16a34a, #0f6d30);
  color: #fff;
  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.45);
}
.btn-success:hover {
  transform: translateY(-1px);
}

/* 3️⃣ Önizleme (PDF) turuncu */
.btn-warning {
  background: linear-gradient(to bottom right, #f97316, #ea580c);
  color: #fff;
  box-shadow: 0 6px 16px rgba(249, 115, 22, 0.45);
}
.btn-warning:hover {
  transform: translateY(-1px);
}

/* 4️⃣ Kaydet gri */
.btn-ghost {
  background: #f3f4f6;
  color: #111827;
  border: 1px solid #d1d5db;
}
.btn-ghost:hover {
  background: #e5e7eb;
}

/* BAŞLIKLARI GÜÇLENDİR */
.page-title {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 2px;
}

.page-subtitle {
  font-size: 12px;
  color: #474e57;
}
.mobile-rows {
  display: none;
}

/* Telefon ve küçük tablet: tabloyu gizle, kartları göster */
@media (max-width: 768px) {
  .table-wrapper {
    display: none;
  }
  .mobile-rows {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
}
@media (max-width: 768px) {
  .offer-row-card {
    background: #ffffff;
    border-radius: 14px;
    border: 1px solid #e5e7eb;
    padding: 6px 8px;
    box-shadow: 0 3px 10px rgba(15, 23, 42, 0.06);
  }

  .offer-row-top {
    display: grid;
    grid-template-columns: 30px 1fr 70px;
    column-gap: 6px;
    align-items: center;
    margin-bottom: 4px;
  }

  .offer-row-no {
    font-weight: 700;
    font-size: 14px;
    text-align: center;
  }

  .offer-row-name {
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
  }

  .offer-row-qty input {
    width: 100%;
    border-radius: 999px;
    border: 1px solid #d1d5db;
    padding: 3px 6px;
    font-size: 12px;
    text-align: center;
  }

  .offer-row-mid {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 11px;
    margin-bottom: 4px;
  }

  .offer-row-code {
    color: #6b7280;
  }

  .offer-row-unit {
    font-weight: 600;
  }

  .offer-row-list {
    font-weight: 600;
  }

  .offer-row-disc {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr)) 70px;
    column-gap: 4px;
    align-items: center;
    margin-bottom: 4px;
  }

  .offer-row-disc .disc-item select {
    width: 100%;
    border-radius: 999px;
    border: 1px solid #d1d5db;
    padding: 2px 4px;
    font-size: 11px;
    background: #fff;
  }

  .offer-row-disc .disc-kdv {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 2px;
  }

  .offer-row-disc .disc-kdv input {
    width: 40px;
    border-radius: 999px;
    border: 1px solid #d1d5db;
    padding: 2px 4px;
    font-size: 11px;
    text-align: center;
  }

  .offer-row-disc .disc-kdv span {
    font-size: 11px;
    color: #6b7280;
  }

  .offer-row-bottom {
    display: grid;
    grid-template-columns: 1.1fr 0.9fr auto;
    align-items: center;
    margin-top: 4px;
  }

  .offer-row-bottom .bottom-tl {
    font-weight: 700;
    font-size: 13px;
  }

  .offer-row-bottom .bottom-usd {
    font-weight: 600;
    font-size: 12px;
    text-align: center;
  }

  .offer-row-bottom .bottom-actions {
    display: flex;
    justify-content: flex-end;
    gap: 4px;
  }

  .mobile-empty {
    font-size: 12px;
    color: #6b7280;
    text-align: center;
    padding: 8px 0;
  }
}


.btn-empty-row {
  background: #2297c5;
  color: #ffffff;
  border: none;
  border-radius: 9px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(12, 64, 141, 0.35);
  margin: 10px;
}

.btn-empty-row:hover {
  background: #16a34a;
  box-shadow: 0 5px 16px rgba(22, 163, 74, 0.45);
}
.mobile-select {
  width: 100%;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  padding: 4px;
  font-size: 12px;
}

</style>


// WEBPACK FOOTER //
// src/views/teklif/add.vue